import type {AdminAuthenticationAdapter} from "@shifath/platform-admin-core";
import type {AccessConnection} from "./access_connection";
export class BackendAccessConnection implements AccessConnection {
  constructor(private readonly auth:AdminAuthenticationAdapter) {}
  restore(){ return this.auth.restore(); }
  signIn(email:string,password:string){ return this.auth.signInWithEmail(email,password); }
  signOut(){ return this.auth.signOut(); }
}
